import {
  LICENSE_EXPIRY_LIST,
  SOFTWARE_LICENSE_DETAIL,
  SOFTWARE_LICENSE_LIST,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

// /license-expiry doesn't share a URL prefix with /software-license, so it can't nest
// under the same parent (react-router v6 throws "Absolute route path ... nested under
// path ... is not valid" when a child's absolute path isn't an extension of its
// parent's) — kept as its own flat top-level entry instead.
export const LicenseRoutes: IAppRoutes = {
  link: SOFTWARE_LICENSE_LIST,
  childrens: [
    {
      link: SOFTWARE_LICENSE_LIST,
      element: guard(() => import('@modules/license/SoftwareLicense'), [SOFTWARE_LICENSE_LIST]),
    },
    {
      link: SOFTWARE_LICENSE_DETAIL({id: ':id'}),
      element: guard(() => import('@modules/license/SoftwareLicense/Detail'), [SOFTWARE_LICENSE_LIST]),
    },
  ],
}

export const LicenseExpiryRoutes: IAppRoutes = {
  link: LICENSE_EXPIRY_LIST,
  element: guard(() => import('@modules/license/LicenseExpiry'), [LICENSE_EXPIRY_LIST]),
}
